var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({staticClass:"rounded-0",attrs:{"rules":_vm.rules,"placeholder":"Usuário","autocomplete":"off","hide-details":"","name":"user","solo":""}},'v-text-field',_vm.fieldProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }